module.exports = __webpack_public_path__ + "img/users-linked-grey.54a2a12a.png";